/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { defineCustomElement } from '@tylertech/forge-core';
import { RadioGroupComponent } from './radio-group';
export * from './radio-group-adapter';
export * from './radio-group-constants';
export * from './radio-group-core';
export * from './radio-group';
export function defineRadioGroupComponent() {
    defineCustomElement(RadioGroupComponent);
}
